export const canCreateThread: Record<string, string[]> = {
  CREATE: ["ADMIN", "SEMBRANETADMIN","AGENCYADMIN","AGENCYNURSE","OWNER","SUPPORT","SPECIALTYSUPPORT"],
  EDIT: ["ADMIN", "SEMBRANETADMIN","AGENCYADMIN","AGENCYNURSE","OWNER","SUPPORT","SPECIALTYSUPPORT"],
  COMMENTS: [ "CAREGIVER","SEMBRANETNURSE","SEMBRANETOFFICE"],
};
